import { AppliancesDTO } from '@hakimo-ui/hakimo/types';
import useAuthenticatedRequest from '../shared/useAuthenticatedRequest';

export function useAppliances(searchParams: string) {
  const url = `/v2/orm/appliances?${searchParams}`;
  const request = new Request(url);

  return useAuthenticatedRequest<AppliancesDTO>(request, {
    queryKey: ['admin-appliances', { searchParams }],
    responseModifier: async (response) => {
      const respJson = await response.json();
      return {
        items: respJson.payload,
        total: respJson.total,
        facets: respJson.facets,
        tenantNames: respJson.tenantNames,
      };
    },
  });
}

export default useAppliances;
